import { FC } from 'react'
import MarkdownRenderer from 'react-markdown-renderer'
import { helpers } from '../../helpers'

type Props = {
    markdown: string
}

const SafeMarkdown: FC<Props> = ({ markdown }) => {
    const source = helpers.sanitizeMarkdownSource(markdown)
    if (!source.trim()) return null
    return <MarkdownRenderer markdown={source} />
}

export default SafeMarkdown
